<template lang="pug">
div
    template(v-if="validDashboardSummaryObjects")
        div(
            @mouseleave="onTableMouseLeave"
            :style="{ flex: '1', display: 'flex', flexDirection: 'column', minHeight: '0', overflow: 'hidden', fontSize: tableFontSize }"
            class="dynamic-table-font big-board-dashboard-table"
        )
            TableFixedHeader.pt-10(
                ref="tableFixedHeader"
                :items="dashboardSummaryObjectsForScroll"
                :num-of-sticky-columns="1"
                :hide-count="true"
                dark-theme=true
                :no-dynamic-height="true"
                :total-row="true"
                :height="tableHeight"
                style="flex: 1; min-height: 0;"
            )
                template(v-slot:column-header-first-title)
                    | {{ displayTitleHeader }}
                template(v-slot:th-default)
                    template(v-if="allowedShowColumn('agents_active')")
                        th.text-center.no-wrap.white--text Agents Active
                    template(v-if="allowedShowColumn('ib_ob_count')")
                        th.text-center.no-wrap.white--text IB/OB Count
                    template(v-if="allowedShowColumn('in_queue')")
                        th.text-center.no-wrap.white--text In Queue
                    template(v-if="allowedShowColumn('longest_wait')")
                        th.text-center.no-wrap.white--text Longest Wait
                    template(v-if="allowedShowColumn('new_appts')")
                        th.text-center.no-wrap.white--text New Appts.
                    template(v-if="allowedShowColumn('service_level')")
                        th.text-center.no-wrap.white--text Service Level
                    template(v-if="allowedShowColumn('agent_drop_percent')")
                        th.text-center.no-wrap.white--text Agent Drop %
                    template(v-if="allowedShowColumn('avg_hold_time')")
                        th.text-center.no-wrap.white--text Avg. Hold Time
                    template(v-if="allowedShowColumn('avg_ib_talk_time')")
                        th.text-center.no-wrap.white--text Avg. IB Talk Time
                    template(v-if="allowedShowColumn('avg_ob_talk_time')")
                        th.text-center.no-wrap.white--text Avg. OB Talk Time
                    template(v-if="allowedShowColumn('agent_status')")
                        th.text-center.no-wrap.white--text Status
                    template(v-if="allowedShowColumn('time_in_status')")
                        th.text-center.no-wrap.white--text Time in Status
                    template(v-if="allowedShowColumn('inbound_calls')")
                        th.text-center.no-wrap.white--text Inbound Calls
                    template(v-if="allowedShowColumn('outbound_calls')")
                        th.text-center.no-wrap.white--text Outbound Calls
                    template(v-if="allowedShowColumn('appointments')")
                        th.text-center.no-wrap.white--text Appointments
                    template(v-if="allowedShowColumn('active_conversations')")
                        th.text-center.no-wrap.white--text Active Conversations
                    template(v-if="allowedShowColumn('longest_waiting')")
                        th.text-center.no-wrap.white--text Longest Waiting
                template(v-slot:column-header-first-content-value="slotProps") 
                    div.view-toggle-icon-container(style="display: flex; align-items: center; gap: 8px;")
                        StrLimitTooltipText(:text="slotProps.item.display_title" :char-limit="30", :hide-tooltip-if-not-max-length="true")
                template(v-slot:tr-default="slotProps")
                    template(v-if="allowedShowColumn('agents_active')")
                        td.text-center {{ slotProps.item.active_agent_count || 0 }}
                    template(v-if="allowedShowColumn('ib_ob_count')")
                        td.text-center.no-wrap {{ (slotProps.item.phone_inbound_call_count || 0) + " / " + (slotProps.item.phone_outbound_call_count || 0)  }}
                    template(v-if="allowedShowColumn('in_queue')")
                        td.text-center {{ calculateCallsWaiting(slotProps.item)}}
                    template(v-if="allowedShowColumn('longest_wait')")
                        template(v-if="calculateLongestWaiting(slotProps.item) > 0")
                            td.text-center {{ calculateLongestWaiting(slotProps.item) | secondsToFullWords }}
                        template(v-else)
                            td.text-center ---
                    template(v-if="allowedShowColumn('new_appts')")
                        td.text-center {{ slotProps.item.appointment_new_count || 0 }}
                    template(v-if="allowedShowColumn('service_level')")
                            td.text-center {{ (calculateServiceLevel(slotProps.item) || 0).toFixed(2) | number }}%
                    template(v-if="allowedShowColumn('agent_drop_percent')")
                        td.text-center {{ (calculateAgentDrop(slotProps.item) || 0).toFixed(2) | number }}%
                    template(v-if="allowedShowColumn('avg_hold_time')")
                        td.text-center
                            v-chip(
                                v-if="calculateAverageHoldTime(slotProps.item) > avgHoldDurationWarningRule.metric || calculateAverageHoldTime(slotProps.item) > avgHoldDurationCriticalRule.metric"
                                :color="getHoldTimeChipColor(calculateAverageHoldTime(slotProps.item))"
                                :class="{ 'flash-animation': calculateAverageHoldTime(slotProps.item) > avgHoldDurationCriticalRule.metric }"
                                dark
                            ) {{calculateAverageHoldTime(slotProps.item) | secondsToFullWords }}
                            span(v-else) {{calculateAverageHoldTime(slotProps.item) | secondsToFullWords }}
                    template(v-if="allowedShowColumn('avg_ib_talk_time')")
                        td.text-center
                            v-chip(
                                v-if="calculateAvgInboundTalkTime(slotProps.item) > ibCallsWarningRule.metric || calculateAvgInboundTalkTime(slotProps.item) > ibCallsCriticalRule.metric"
                                :color="getInboundTalkTimeChipColor(calculateAvgInboundTalkTime(slotProps.item))"
                                :class="{ 'flash-animation' : calculateAvgInboundTalkTime(slotProps.item) > ibCallsCriticalRule.metric }"
                                dark
                            ) {{calculateAvgInboundTalkTime(slotProps.item) | secondsToFullWords }}
                            span(v-else) {{calculateAvgInboundTalkTime(slotProps.item) | secondsToFullWords }}
                    template(v-if="allowedShowColumn('avg_ob_talk_time')")
                        td.text-center
                            v-chip(
                                v-if="calculateAvgOutboundTalkTime(slotProps.item) > obCallsWarningRule.metric || calculateAvgOutboundTalkTime(slotProps.item) > obCallsCriticalRule.metric" 
                                :color="getOutboundTalkTimeChipColor(calculateAvgOutboundTalkTime(slotProps.item))" 
                                :class="{ 'flash-animation' : calculateAvgOutboundTalkTime(slotProps.item) > obCallsCriticalRule.metric }" 
                                dark
                            ) {{calculateAvgOutboundTalkTime(slotProps.item) | secondsToFullWords }}
                            span(v-else) {{calculateAvgOutboundTalkTime(slotProps.item) | secondsToFullWords }}
                    template(v-if="allowedShowColumn('agent_status')")
                        td.text-center
                            v-chip(
                                :class="{ 'flash-animation': getAgentStatusCriticalFlash(slotProps.item) }"
                                :color="getAgentStatusChipColor(slotProps.item)"
                                dark
                                style="justify-content: center;"
                            )
                                v-icon(left small) {{ getAgentStatusIcon(slotProps.item) }}
                                span {{ slotProps.item.agent_status || 'N/a' }}
                    template(v-if="allowedShowColumn('time_in_status')")
                        td.text-center
                            template(v-if="(slotProps.item.time_in_status || 0) < 600")
                                strong {{ (slotProps.item.time_in_status || 0) | secondsToFullWords }}

                            v-tooltip(top v-else)
                                template(v-slot:activator='{ on, attrs }')
                                    span(v-bind="attrs" v-on="on" role="text")
                                        Timeago(
                                            :datetime="slotProps.item.created_at"
                                            :auto-update="60"
                                        )
                                span {{ (slotProps.item.time_in_status || 0) | secondsToFullWords }}
                    template(v-if="allowedShowColumn('inbound_calls')")
                        td.text-center {{ (slotProps.item.inbound_calls_today || 0) | number }}
                    template(v-if="allowedShowColumn('outbound_calls')")
                        td.text-center {{ (slotProps.item.outbound_calls_today || 0) | number }}
                    template(v-if="allowedShowColumn('appointments')")
                        td.text-center {{ (slotProps.item.appointments_created_today || 0) | number }}
                    template(v-if="allowedShowColumn('active_conversations')")
                        td.text-center {{ (slotProps.item.active_conversations || 0) | number }}
                    template(v-if="allowedShowColumn('longest_waiting')")
                        template(v-if="slotProps.item.unresponded_to_time_in_seconds > 0")
                            td.text-center {{ (slotProps.item.unresponded_to_time_in_seconds || 0) | secondsToFullWords }}
                        template(v-else)
                            td.text-center N/a
                template(v-slot:total-row-tr-default)
                    template(v-if="allowedShowColumn('agents_active')")
                        td.text-center 
                            | {{ totalActiveAgents }}
                    template(v-if="allowedShowColumn('ib_ob_count')")
                        td.text-center.no-wrap {{ totalInboundCalls }} / {{ totalOutboundCalls }}
                    template(v-if="allowedShowColumn('in_queue')")
                        td.text-center {{ totalCallsWaiting }}
                    template(v-if="allowedShowColumn('longest_wait')")
                        td.text-center {{ maxLongestWaiting | secondsToFullWords }}
                    template(v-if="allowedShowColumn('new_appts')")
                        td.text-center {{ totalNewAppointments }}
                    template(v-if="allowedShowColumn('service_level')")
                        td.text-center {{ (calculateTotalServiceLevel || 0).toFixed(2) | number }}%
                    template(v-if="allowedShowColumn('agent_drop_percent')")
                        td.text-center {{ (calculateTotalAgentDrop || 0).toFixed(2) | number }}%
                    template(v-if="allowedShowColumn('avg_hold_time')")
                        td.text-center {{ calculateTotalAverageHoldTime | secondsToFullWords }}
                    template(v-if="allowedShowColumn('avg_ib_talk_time')")
                        td.text-center {{ calculateTotalAvgInboundTalkTime | secondsToFullWords }}
                    template(v-if="allowedShowColumn('avg_ob_talk_time')")
                        td.text-center {{ calculateTotalAvgOutboundTalkTime | secondsToFullWords }}
                    template(v-if="allowedShowColumn('agent_status')")
                        td.text-center ---
                    template(v-if="allowedShowColumn('time_in_status')")
                        td.text-center ---
                    template(v-if="allowedShowColumn('inbound_calls')")
                        td.text-center {{ totalAgentInboundCalls }}
                    template(v-if="allowedShowColumn('outbound_calls')")
                        td.text-center {{ totalAgentOutboundCalls }}
                    template(v-if="allowedShowColumn('appointments')")
                        td.text-center {{ totalAgentAppointments }}
                    template(v-if="allowedShowColumn('active_conversations')")
                        td.text-center {{ totalActiveConversations }}
                    template(v-if="allowedShowColumn('longest_waiting')")
                        template(v-if="maxAgentLongestWaiting > 0")
                            td.text-center {{ maxAgentLongestWaiting | secondsToFullWords }}
                        template(v-else)
                            td.text-center N/a
    template(v-else)
        div(style="flex: 1; display: flex; align-items: center; justify-content: center; overflow: hidden;")
            v-alert.text-center.custom-alert(
                outlined 
                type='warning'
                dense 
                border='left' 
                :style="{margin: '16px', marginTop: '48px', width: '100%', fontSize: `${100 / (tableRowCount * 2.5)}vh`}"
            )
                | No data found for this account. Data is pushed every minute and may be processing. 
</template>

<script lang="ts">
import Vue from 'vue';

// Helpers
import { adjustedAgentDropRate, agentDropRate, dropRate } from '@/helpers/dashboard_summary';
import { clamp } from '@/helpers/math';
import { debounce } from '@/helpers/coroutine';

// Components
import StrLimitTooltipText from '@/components/shared/str_limit_tooltip_text.vue';
import TableFixedHeader from '@/components/shared/table_fixed_header.vue';

export default Vue.extend({
    data() {
        return {
            handleResize: null,
            handleScroll: null,
            handleScrollDebounce: null,
            isTableScrollPaused: false,
            lastProgrammaticScrollAt: 0,
            measuredSingleRowHeight: 0,
            measuredScrollContainerHeight: 0,
            minRowsForScrollDuplicates: 8,
            renderColumnRules: [
                { header: 'IB/OB Count',            key: 'ib_ob_count',             allowedViews: ['account-view', 'teams-view'] },
                { header: 'In Queue',               key: 'in_queue',                allowedViews: ['account-view', 'teams-view'] },
                { header: 'Longest Wait',           key: 'longest_wait',            allowedViews: ['account-view', 'teams-view'] },
                { header: 'New Appts.',             key: 'new_appts',               allowedViews: ['account-view', 'teams-view'] },
                { header: 'Service Level',          key: 'service_level',           allowedViews: ['account-view', 'teams-view'] },
                { header: 'Agent Drop %',           key: 'agent_drop_percent',      allowedViews: ['account-view', 'teams-view'] },
                { header: 'Avg. Hold Time',         key: 'avg_hold_time',           allowedViews: ['account-view', 'teams-view'] },
                { header: 'Avg. IB Talk Time',      key: 'avg_ib_talk_time',        allowedViews: ['account-view', 'teams-view'] },
                { header: 'Avg. OB Talk Time',      key: 'avg_ob_talk_time',        allowedViews: ['account-view', 'teams-view'] },
                { header: 'Agents Active',          key: 'agents_active',           allowedViews: ['account-view', 'teams-view'] },
                { header: 'Status',                 key: 'agent_status',            allowedViews: ['agents-view'] },
                { header: 'Time in Status',         key: 'time_in_status',          allowedViews: ['agents-view'] },
                { header: 'Inbound Calls',          key: 'inbound_calls',           allowedViews: ['agents-view'] },
                { header: 'Outbound Calls',         key: 'outbound_calls',          allowedViews: ['agents-view'] },
                { header: 'Appointments',           key: 'appointments',            allowedViews: ['agents-view'] },
                { header: 'Active Conversations',   key: 'active_conversations',    allowedViews: ['agents-view'] },
                { header: 'Longest Waiting',        key: 'longest_waiting',         allowedViews: ['agents-view'] },
            ],
            scrollPaddingForLoop: false,
            scrollPaddingLockContainerHeight: null,
            scrollableElement: null as HTMLElement | null,
            tableScrollHoverPauseArmed: false,
            tableScrollInterval: null as any,
            tableScrollPosition: 0,
            tableScrollResizeObserver: null as ResizeObserver | null,
            tableScrollRestartTimeout: null as any,
            tableScrollSpeed: 0.5,
            tableScrollStartRetryTimeout: null as any,
            teams: [],
            windowHeight: window.innerHeight,
        }
    },
    methods: {
        allowedShowColumn(key: string) {
            return this.renderColumnRules.find(rule => rule.key === key)?.allowedViews.includes(this.displayView);
        },
        clamp,
        calculateAdjustedAgentDrop(item: any){
            return adjustedAgentDropRate(item);
        },
        calculateAgentDrop(item: any){
            return agentDropRate(item);
        },
        calculateAdjustedVoiceMail(item: any){
            return item.phone_missed_call_voice_mail_count > 0 && item.phone_inbound_call_count > 0 ? this.calculatePercentage(item.phone_missed_call_voice_mail_count - (item?.phone_missed_call_voice_mail_contact_count || 0), item.phone_inbound_call_count) : 0;
        },
        calculateAverageHoldTime(item: any){
            return item.total_inbound_hold_duration > 0 && item.phone_inbound_call_count > 0 ? Math.floor(item.total_inbound_hold_duration / item.phone_inbound_call_count) : 0;
        },
        calculateAvgInboundTalkTime(item: any){
            return item.total_inbound_talk_duration > 0 && item.phone_inbound_call_count > 0 ? Math.floor(item.total_inbound_talk_duration / item.phone_inbound_call_count) : 0;
        },
        calculateAvgOutboundTalkTime(item: any){
            return item.total_outbound_talk_duration > 0 && item.phone_outbound_call_count > 0 ? Math.floor(item.total_outbound_talk_duration / item.phone_outbound_call_count) : 0;
        },
        calculateCallsWaiting(item: any) {
            if (!this.callsWaiting) return 0;

            // find base dashboard summary
            const baseDashboardSummary = this.baseDashboardSummaryBySummaryId?.get(item.dashboard_summary_id);
            if (!baseDashboardSummary) {
                return 0;
            }

            switch (baseDashboardSummary?.base_dashboard_summary?.owner_type) {
                case "organization":
                    return this.callsWaiting.filter(call => call.organization_id === baseDashboardSummary?.base_dashboard_summary?.owner_id).length;
                case "team":
                    const team = this.teams?.find(team => team.team_id === baseDashboardSummary?.base_dashboard_summary?.owner_id);
                    if (!team) {
                        return 0;
                    }

                    return this.callsWaiting.filter(call => team.user_ids.includes(call.user_id)).length;
                default:
                    return 0;
            }
        },
        calculateLongestWaiting(item: any) {
            if (!this.callsWaiting) return 0;

            // find base dashboard summary
            const baseDashboardSummary = this.baseDashboardSummaryBySummaryId?.get(item.dashboard_summary_id);
            if (!baseDashboardSummary) {
                return 0;
            }

            switch (baseDashboardSummary?.base_dashboard_summary?.owner_type) {
                case "organization":
                    const orgCalls = this.callsWaiting?.filter(call => call.organization_id === baseDashboardSummary?.base_dashboard_summary?.owner_id);
                    if (orgCalls?.length === 0) return 0;

                    // Find the call with the longest hold time
                    return Math.max(...orgCalls.map(call => call.hold_time_in_seconds || 0));
                case "team":
                    const team = this.teams?.find(team => team.team_id === baseDashboardSummary?.base_dashboard_summary?.owner_id);
                    if (!team) {
                        return 0;
                    }

                    const teamCalls = this.callsWaiting?.filter(call => team.user_ids?.includes(call.user_id));
                    if (teamCalls?.length === 0) return 0;

                    // Find the call with the longest hold time
                    return Math.max(...teamCalls.map(call => call.hold_time_in_seconds || 0));
                default:
                    return 0;
            }
        },
        calculatePercentage(x, y) {
            if (!x || !y) {
                return 0;
            }
            return (x / y) * 100.0;
        },
        calculateServiceLevel(item: any){
            if (item.phone_inbound_call_count > 0) {
                return 100.0 - this.calculateAdjustedAgentDrop(item) - this.calculateAdjustedVoiceMail(item);
            }
            return null;
        },
        calculateTotalCalls(item: any){
            return item.phone_inbound_call_count + item.phone_outbound_call_count;
        },
        getHoldTimeChipColor(holdTime) {
            switch (true) {
                case holdTime > this.avgHoldDurationCriticalRule.metric:
                    return this.avgHoldDurationCriticalRule.display_color;
                case holdTime > this.avgHoldDurationWarningRule.metric:
                    return this.avgHoldDurationWarningRule.display_color;
                default:
                    return '';
            }
        },
        getInboundTalkTimeChipColor(timeInSeconds) {
            switch (true) {
                case timeInSeconds > this.ibCallsCriticalRule.metric:
                    return this.ibCallsCriticalRule.display_color;
                case timeInSeconds > this.ibCallsWarningRule.metric:
                    return this.ibCallsWarningRule.display_color;
                default:
                    return '';
            }
        },
        getOutboundTalkTimeChipColor(timeInSeconds) {
            switch (true) {
                case timeInSeconds > this.obCallsCriticalRule.metric:
                    return this.obCallsCriticalRule.display_color;
                case timeInSeconds > this.obCallsWarningRule.metric:
                    return this.obCallsWarningRule.display_color;
                default:
                    return '';
            }
        },
        getAgentStatusIcon(item: any): string {
            if (item?.is_online === false) {
                return 'mdi-account-off';
            }
            const agentStatusType = item?.agent_status_type;
            switch (agentStatusType) {
                case 0: return 'mdi-phone-incoming';
                case 1: return 'mdi-phone-outgoing';
                case 2: return 'mdi-phone-incoming-outgoing';
                case 3: return 'mdi-phone-hangup';
                case 6: return 'mdi-cellphone-text';
                case 7: return 'mdi-email';
                default: return 'mdi-phone-hangup';
            }
        },
        getAgentStatusChipColor(item: any): string {
            if (item?.is_online === false) {
                return 'grey';
            }
            const timeInSeconds = item?.time_in_status || 0;
            if (timeInSeconds > this.agentStatusCriticalRule.metric) {
                return this.agentStatusCriticalRule.display_color;
            }
            if (timeInSeconds > this.agentStatusWarningRule.metric) {
                return this.agentStatusWarningRule.display_color;
            }
            return 'var(--success)';
        },
        getAgentStatusCriticalFlash(item: any): boolean {
            return !!(item?.is_online && (item?.time_in_status || 0) > this.agentStatusCriticalRule.metric);
        },
        getRowTextColor(item: any){
            switch (item) {
                case item.toBeHighlighted:
                    return 'black--text';
                default:
                    return 'white--text';
            }
        },
        getTableScrollableElement() {
            const tableComponent = this.$refs.tableFixedHeader as any;
            if (!tableComponent) return null;
            
            // Use the getScrollableElement method from TableFixedHeader if available
            if (tableComponent.getScrollableElement) {
                const element = tableComponent.getScrollableElement();
                if (element) return element;
            }
            
            // Fallback: find scrollable element manually
            const rootEl = tableComponent.$el;
            if (!rootEl) return null;

            const fixedHeaderWrapper = rootEl.querySelector('.v-data-table__wrapper');
            if (fixedHeaderWrapper) return fixedHeaderWrapper;
            
            const selectors = [
                '.v-simple-table',
                '.table-x-scroll',
                'table',
                '[style*="overflow"]'
            ];
            
            for (const selector of selectors) {
                const element = rootEl.querySelector(selector);
                if (element) {
                    const computedStyle = window.getComputedStyle(element);
                    const hasScroll = computedStyle.overflow === 'auto' ||
                                    computedStyle.overflow === 'scroll' ||
                                    computedStyle.overflowY === 'auto' ||
                                    computedStyle.overflowY === 'scroll';
                    
                    if (hasScroll || element.scrollHeight > element.clientHeight) {
                        return element;
                    }
                }
            }
            
            // Find any element with scrollable content
            const allElements = rootEl.querySelectorAll('*');
            for (const element of allElements) {
                if (element.scrollHeight > element.clientHeight) {
                    return element;
                }
            }
            
            return null;
        },
        shouldRowFlash(item: any) {
            const holdTime = this.calculateAverageHoldTime(item);
            const inboundTalkTime = this.calculateAvgInboundTalkTime(item);
            const outboundTalkTime = this.calculateAvgOutboundTalkTime(item);   
            return holdTime > this.avgHoldDurationCriticalRule.metric && inboundTalkTime > this.ibCallsCriticalRule.metric && outboundTalkTime > this.obCallsCriticalRule.metric;
        },
        startTableScroll(clear: boolean = false) {

            if (clear) {
                this.clearTableScrollStartRetry();
                if (this.tableScrollInterval) {
                    clearInterval(this.tableScrollInterval);
                    this.tableScrollInterval = null;
                }

                this.tableScrollPosition = 0;
                this.isTableScrollPaused = false;
                this.lastProgrammaticScrollAt = 0;
                this.scrollableElement = null;
                this.scrollPaddingForLoop = false;
                this.scrollPaddingLockContainerHeight = null;
            }

            if (this.tableScrollInterval || !this.validDashboardSummaryObjects) return;

            this.tryStartTableScroll(0);
        },
        tryStartTableScroll(retryCount: number = 0) {
            if (this.tableScrollInterval || !this.validDashboardSummaryObjects) return;

            this.$nextTick(() => {
                if (this.tableScrollInterval || !this.validDashboardSummaryObjects) return;

                const tableComponent = this.$refs.tableFixedHeader as any;
                tableComponent?.handleTableHeight?.();

                const paddingChanged = this.bootstrapScrollMeasurements();

                const attachTableScrollInterval = () => {
                    if (this.tableScrollInterval || !this.validDashboardSummaryObjects) return;

                    tableComponent?.handleTableHeight?.();

                    const scrollableElement = this.getTableScrollableElement();
                    if (!scrollableElement) {
                        if (retryCount < 80) {
                            this.clearTableScrollStartRetry();
                            this.tableScrollStartRetryTimeout = setTimeout(() => {
                                this.tableScrollStartRetryTimeout = null;
                                this.tryStartTableScroll(retryCount + 1);
                            }, 25);
                        }
                        return;
                    }

                    this.scrollableElement = scrollableElement;
                    this.isTableScrollPaused = false;
                    this.observeTableScrollContainer();

                    this.tableScrollInterval = setInterval(() => {
                        const element = this.getTableScrollableElement();
                        if (!element) return;

                        const tbody = element.querySelector('tbody');
                        const firstDataRow = tbody ? tbody.querySelector('tr:not(.total-row-footer)') : null;
                        const singleRowHeight = firstDataRow ? firstDataRow.getBoundingClientRect().height : 0;
                        const containerHeight = element.clientHeight;
                        this.measuredSingleRowHeight = singleRowHeight;
                        this.measuredScrollContainerHeight = containerHeight;
                        this.updateScrollPaddingDecision(
                            singleRowHeight,
                            containerHeight,
                            this.dashboardSummaryObjects?.length ?? 0,
                        );

                        if (this.isTableScrollPaused) return;
                        if (this.shouldPauseTableScrollForHover()) return;
                        if (element.scrollHeight <= element.clientHeight) {
                            return;
                        }

                        this.lastProgrammaticScrollAt = Date.now();

                        const scrollHeight = element.scrollHeight;
                        const clientHeight = element.clientHeight;
                        const maxScroll = scrollHeight - clientHeight;

                        const scrollListLength = this.dashboardSummaryObjectsForScroll.length;
                        const firstBlockRowCount = scrollListLength > 20 ? scrollListLength - 20 : this.dashboardSummaryObjects.length;
                        const originalBlockHeight = singleRowHeight > 0
                            ? firstBlockRowCount * singleRowHeight
                            : (() => {
                                const dataRowCount = firstBlockRowCount + 20;
                                return dataRowCount > 0 ? scrollHeight * (firstBlockRowCount / (dataRowCount + 1)) : 0;
                            })();

                        // When we've scrolled into the duplicate block, rewind so we show the same content — seamless loop.
                        if (maxScroll > 0 && originalBlockHeight > 0 && element.scrollTop >= originalBlockHeight) {
                            this.tableScrollPosition = element.scrollTop - originalBlockHeight;
                            element.scrollTop = this.tableScrollPosition;
                        } else {
                            this.tableScrollPosition += this.tableScrollSpeed * Number(this.cookieSettingsObject.tableScrollSpeedMultiplier);
                            element.scrollTop = Math.min(this.tableScrollPosition, maxScroll);
                            this.tableScrollPosition = element.scrollTop;
                        }
                    }, 15);
                };

                if (paddingChanged) {
                    this.$nextTick(attachTableScrollInterval);
                    return;
                }

                attachTableScrollInterval();
            });
        },
        bootstrapScrollMeasurements(): boolean {
            const tableComponent = this.$refs.tableFixedHeader as any;
            const rootEl = tableComponent?.$el;
            if (!rootEl) return false;

            const tbody = rootEl.querySelector('tbody');
            const firstDataRow = tbody ? tbody.querySelector('tr:not(.total-row-footer)') : null;
            const singleRowHeight = firstDataRow ? firstDataRow.getBoundingClientRect().height : 0;
            const scrollableElement = this.getTableScrollableElement();
            const containerHeight = scrollableElement?.clientHeight ?? (Number(this.tableHeight) || 0);

            if (singleRowHeight <= 0 || containerHeight <= 0) return false;

            const previousPadding = this.scrollPaddingForLoop;
            this.updateScrollPaddingDecision(
                singleRowHeight,
                containerHeight,
                this.dashboardSummaryObjects?.length ?? 0,
            );
            return this.scrollPaddingForLoop !== previousPadding;
        },
        getTableScrollWrapper(): HTMLElement | null {
            return this.$el?.querySelector('.big-board-dashboard-table') ?? null;
        },
        shouldPauseTableScrollForHover(): boolean {
            if (!this.cookieSettingsObject.pauseTableScrollOnHover) return false;
            if (!this.tableScrollHoverPauseArmed) return false;

            return !!this.getTableScrollWrapper()?.matches(':hover');
        },
        onTableMouseLeave() {
            const wrapper = this.getTableScrollWrapper();
            if (wrapper?.matches(':hover')) return;

            this.tableScrollHoverPauseArmed = true;
            this.isTableScrollPaused = false;

            if (!this.tableScrollInterval) {
                this.startTableScroll();
            }
        },
        observeTableScrollContainer() {
            this.disconnectTableScrollResizeObserver();
            if (typeof ResizeObserver === 'undefined') return;

            const tableComponent = this.$refs.tableFixedHeader as any;
            const rootEl = tableComponent?.$el;
            if (!rootEl) return;

            this.tableScrollResizeObserver = new ResizeObserver(() => {
                if (!this.tableScrollInterval && this.validDashboardSummaryObjects) {
                    this.tryStartTableScroll(0);
                }
            });
            this.tableScrollResizeObserver.observe(rootEl);
        },
        disconnectTableScrollResizeObserver() {
            if (this.tableScrollResizeObserver) {
                this.tableScrollResizeObserver.disconnect();
                this.tableScrollResizeObserver = null;
            }
        },
        resetTableScrollHoverState() {
            this.tableScrollHoverPauseArmed = false;
        },
        clearTableScrollStartRetry() {
            if (this.tableScrollStartRetryTimeout) {
                clearTimeout(this.tableScrollStartRetryTimeout);
                this.tableScrollStartRetryTimeout = null;
            }
        },
        clearTableScrollRestartTimeout() {
            if (this.tableScrollRestartTimeout) {
                clearTimeout(this.tableScrollRestartTimeout);
                this.tableScrollRestartTimeout = null;
            }
        },
        scheduleTableScrollRestart(clear: boolean = false) {
            this.clearTableScrollRestartTimeout();
            this.tableScrollRestartTimeout = setTimeout(() => {
                this.tableScrollRestartTimeout = null;
                this.startTableScroll(clear);
            }, 100);
        },
        stopTableScroll() {
            this.clearTableScrollStartRetry();
            this.clearTableScrollRestartTimeout();
            this.disconnectTableScrollResizeObserver();
            if (this.tableScrollInterval) {
                clearInterval(this.tableScrollInterval);
                this.tableScrollInterval = null;
            }
            this.isTableScrollPaused = true;
        },
        updateScrollPaddingDecision(singleRowHeight: number, containerHeight: number, originalCount: number) {
            if (singleRowHeight <= 0 || containerHeight <= 0 || originalCount <= 0) {
                this.scrollPaddingForLoop = false;
                this.scrollPaddingLockContainerHeight = null;
                return;
            }

            if (originalCount < this.minRowsForScrollDuplicates) {
                this.scrollPaddingForLoop = false;
                this.scrollPaddingLockContainerHeight = null;
                return;
            }

            const totalRowCount = originalCount + 2;
            const contentHeightWithNormalRecords = totalRowCount * singleRowHeight;
            const onTolerancePx = 2;
            const offSlackPx = 48;

            if (this.scrollPaddingForLoop) {
                const refContainerHeight = this.scrollPaddingLockContainerHeight ?? containerHeight;
                if (contentHeightWithNormalRecords < refContainerHeight - offSlackPx) {
                    this.scrollPaddingForLoop = false;
                    this.scrollPaddingLockContainerHeight = null;
                }
                return;
            }

            if (contentHeightWithNormalRecords >= containerHeight - onTolerancePx) {
                this.scrollPaddingForLoop = true;
                this.scrollPaddingLockContainerHeight = containerHeight;
            }
        },
        cleanupScrollListener() {
            if (this.handleScroll && this.scrollableElement) {
                this.scrollableElement.removeEventListener('scroll', this.handleScroll);
                this.scrollableElement = null;
            }
        },
    },
    computed: {
        agentStatusCriticalRule() {
            const rule = this.rules?.find(rule => rule.rule_action === 'agent_status_critical_account');
            return {
                metric: rule?.metric || 18000,
                display_color: rule?.display_color || 'var(--error)',
            };
        },
        agentStatusWarningRule() {
            const rule = this.rules?.find(rule => rule.rule_action === 'agent_status_warning_account');
            return {
                metric: rule?.metric || 120,
                display_color: rule?.display_color || 'var(--orange)',
            };
        },
        avgHoldDurationWarningRule() {
            const rule = this.rules?.find(rule => rule.rule_action === 'avg_hold_duration_warning');
            return {
                metric: rule?.metric || 30, 
                display_color: rule?.display_color || 'var(--orange)',
            };
        },
        avgHoldDurationCriticalRule() {
            const rule = this.rules?.find(rule => rule.rule_action === 'avg_hold_duration_critical');
            return {
                metric: rule?.metric || 45, 
                display_color: rule?.display_color || 'var(--error)',
            };
        },
        calculateTotalAgentDrop() {
            const totalDropped = this.dashboardSummaryObjects.reduce((sum, org) =>
            sum + (org.phone_inbound_dropped_count || 0), 0);

            return dropRate(totalDropped, this.totalInboundCalls);
        },
        calculateTotalAverageHoldTime() {
            const totalHoldDuration = this.dashboardSummaryObjects.reduce((sum, org) => 
            sum + (org.total_inbound_hold_duration || 0), 0);
            return this.totalInboundCalls > 0 ? Math.floor(totalHoldDuration / this.totalInboundCalls) : 0;
        },
        calculateTotalAvgInboundTalkTime() {
            const totalTalkDuration = this.dashboardSummaryObjects.reduce((sum, org) => 
            sum + (org.total_inbound_talk_duration || 0), 0);
            return this.totalInboundCalls > 0 ? Math.floor(totalTalkDuration / this.totalInboundCalls) : 0;
        },
        calculateTotalAvgOutboundTalkTime() {
            const totalTalkDuration = this.dashboardSummaryObjects.reduce((sum, org) => 
            sum + (org.total_outbound_talk_duration || 0), 0);
            return this.totalOutboundCalls > 0 ? Math.floor(totalTalkDuration / this.totalOutboundCalls) : 0;
        },
        calculateTotalServiceLevel() {
            const totalInbound = this.totalInboundCalls;
            if (totalInbound === 0) return 0;
            
            const totalDropped = this.dashboardSummaryObjects.reduce((sum, org) =>
            sum + ((org.phone_inbound_dropped_count || 0) - (org?.phone_missed_call_agent_dropped_contact_count || 0)), 0);
            const totalVoicemail = this.dashboardSummaryObjects.reduce((sum, org) => 
            sum + (org.phone_missed_call_voice_mail_count - (org?.phone_missed_call_voice_mail_contact_count || 0)), 0);
            
            return 100.0 - dropRate(totalDropped, totalInbound) - ((totalVoicemail / totalInbound) * 100);
        },
        dashboardSummaryObjectsForScroll() {
            const items = this.dashboardSummaryObjects || [];
            if (!items.length) return [];

            if (!this.scrollPaddingForLoop) {
                return items;
            }

            const MAX_DUPLICATES = 20;
            const duplicates = [];

            for (let i = 0; i < MAX_DUPLICATES; i++) {
                duplicates.push(items[i % items.length]);
            }

            return [...items, ...duplicates];
        },
        displayTitleHeader() {
            switch (this.displayView) {
                case "account-view":
                    return "Organization";
                case "teams-view":
                    return "Team";
                case "agents-view":
                    return "Agent";
                default:
                    return "";
            }
        },
        ibCallsWarningRule() {
            const rule = this.rules?.find(rule => rule.rule_action === 'ib_calls_warning');
            return {
                metric: rule?.metric || 120, // Defaults if rules aren't created
                display_color: rule?.display_color || 'var(--orange)', // Default color if rules aren't created
            };
        },
        ibCallsCriticalRule() {
            const rule = this.rules?.find(rule => rule.rule_action === 'ib_calls_critical');
            return {
                metric: rule?.metric || 180, 
                display_color: rule?.display_color || 'var(--error)',
            };
        },
        maxLongestWaiting() {
            if (!this.callsWaiting?.length) return 0;
            return Math.max(...this.callsWaiting.map(call => call.hold_time_in_seconds || 0));
        },
        obCallsWarningRule() {
            const rule = this.rules?.find(rule => rule.rule_action === 'ob_calls_warning');
            return {
                metric: rule?.metric || 120, 
                display_color: rule?.display_color || 'var(--orange)',
            };
        },
        obCallsCriticalRule() {
            const rule = this.rules?.find(rule => rule.rule_action === 'ob_calls_critical');
            return {
                metric: rule?.metric || 180,
                display_color: rule?.display_color || 'var(--error)',
            };
        },
        shouldShowScopeButton() {
            return this.displayView === "account-view" || this.displayView === "teams-view";
        },
        tableRowCount(){
            return this.dashboardSummaryObjects?.length || 13;
        },
        tableHeight() {
            Vue.nextTick(() => {
                this.$refs.tableFixedHeader.handleTableHeight();
            });

            return this.windowHeight - (this.cookieSettingsObject.showUserCardSection ? 150 : 50);
        },
        tableFontSize() {
            return '1.65vh';
        },
        totalInboundCalls() {
            return this.dashboardSummaryObjects.reduce((sum, org) => sum + (org.phone_inbound_call_count || 0), 0);
        },
        totalOutboundCalls() {
            return this.dashboardSummaryObjects.reduce((sum, org) => sum + (org.phone_outbound_call_count || 0), 0);
        },
        totalCallsWaiting() {
            return this.callsWaiting?.length || 0;
        },
        totalNewAppointments() {
            return this.dashboardSummaryObjects.reduce((sum, org) => sum + (org.appointment_new_count || 0), 0);
        },
        totalAgentInboundCalls() {
            return this.dashboardSummaryObjects.reduce((sum, item) => sum + (item.inbound_calls_today || 0), 0);
        },
        totalAgentOutboundCalls() {
            return this.dashboardSummaryObjects.reduce((sum, item) => sum + (item.outbound_calls_today || 0), 0);
        },
        totalAgentAppointments() {
            return this.dashboardSummaryObjects.reduce((sum, item) => sum + (item.appointments_created_today || 0), 0);
        },
        totalActiveConversations() {
            return this.dashboardSummaryObjects.reduce((sum, item) => sum + (item.active_conversations || 0), 0);
        },
        maxAgentLongestWaiting() {
            if (!this.dashboardSummaryObjects?.length) return 0;
            return Math.max(0, ...this.dashboardSummaryObjects.map(item => item.unresponded_to_time_in_seconds || 0));
        },
        validDashboardSummaryObjects() {
            return this.dashboardSummaryObjects?.length > 0;
        },
    },
    components: {
        StrLimitTooltipText,
        TableFixedHeader,
    },
    props: {
        callsWaiting: {
            type: Array,
            required: true,
        },
        cookieSettingsObject: {
            type: Object,
            required: true,
        },
        baseDashboardSummaryBySummaryId: {
            type: null,
            required: false,
        },
        dashboardSummaryObjects: {
            type: Array,
            required: false,
        },
        displayView: {
            type: String,
            required: true,
        },
        rules: {
            type: Array,
            required: false,
        },
        scopeParameters: {
            type: Object,
            required: false,
        },
        totalActiveAgents: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    watch: {
        displayView: {
            handler() {
                this.resetTableScrollHoverState();
                this.scrollPaddingForLoop = false;
                this.scrollPaddingLockContainerHeight = null;
                this.$nextTick(() => {
                    this.scheduleTableScrollRestart(true);
                });
            }
        },
        dashboardSummaryObjects: {
            handler(newVal: any[] | undefined, oldVal: any[] | undefined) {
                const newLen = newVal?.length ?? 0;
                const oldLen = oldVal?.length ?? 0;
                if (newLen !== oldLen) {
                    this.scrollPaddingForLoop = false;
                    this.scrollPaddingLockContainerHeight = null;
                }
                if (this.validDashboardSummaryObjects) {
                    if (newLen !== oldLen) {
                        this.scheduleTableScrollRestart(true);
                    }
                } else {
                    this.resetTableScrollHoverState();
                    this.disconnectTableScrollResizeObserver();
                    this.scrollPaddingForLoop = false;
                    this.scrollPaddingLockContainerHeight = null;
                    this.stopTableScroll();
                }
            },
        },
        validDashboardSummaryObjects: {
            handler(val) {
                if (val) {
                    // Create handler if it doesn't exist
                    if (!this.handleScroll) {
                        this.handleScroll = () => {
                            if (Date.now() - this.lastProgrammaticScrollAt < 100) {
                                return;
                            }
                            if (!this.tableScrollHoverPauseArmed) {
                                return;
                            }

                            this.isTableScrollPaused = true;
                            this.handleScrollDebounce();
                        };
                    }
                    
                    // Reattach listener to new element when table reloads
                    this.$nextTick(() => {
                        this.observeTableScrollContainer();

                        // Clean up old listener first if it exists
                        this.cleanupScrollListener();
                        
                        const element = this.getTableScrollableElement();
                        if (element && this.handleScroll) {
                            this.scrollableElement = element;
                            element.addEventListener('scroll', this.handleScroll);
                        }
                    });
                } else {
                    // Clean up scroll listener when table is unloaded
                    this.scrollPaddingForLoop = false;
                    this.scrollPaddingLockContainerHeight = null;
                    this.cleanupScrollListener();
                }
            }
        },
    },
    async created() {
        this.teams = await DataBank.loadResource('teams');
    },
    destroyed() {
        if (this.handleResize) {
            window.removeEventListener('resize', this.handleResize);
        }

        this.clearTableScrollStartRetry();
        this.clearTableScrollRestartTimeout();
        this.disconnectTableScrollResizeObserver();
        this.cleanupScrollListener();
    },
    mounted() {
        this.$nextTick(() => {
            this.startTableScroll()
        });

        this.handleResize = () => {
            this.windowHeight = window.innerHeight;
            this.scrollPaddingForLoop = false;
            this.scrollPaddingLockContainerHeight = null;
            this.$nextTick(() => {
                if (!this.tableScrollInterval && this.validDashboardSummaryObjects) {
                    this.tryStartTableScroll(0);
                }
            });
        };
        this.handleScrollDebounce = debounce(() => {
            this.isTableScrollPaused = false;

            const element = this.getTableScrollableElement();
            if (element) {
                this.tableScrollPosition = element.scrollTop;
            }
        }, 50);

        window.addEventListener('resize', this.handleResize);
    },
})
</script>

<style lang="scss" scoped>

    .v-data-table__wrapper {
        max-height: 95vh;
        overflow-y: auto;
        
        &:hover {
            .scroll-pause {
                opacity: 1;
            }
        }
    }

    .v-col {
        // Make sure the table inside takes full height of the column
        ::v-deep .v-data-table {
            height: 100%;
            width: 100%;
            table-layout: fixed;
        }

        ::v-deep .v-data-table__wrapper {
        max-width: 100%;
        overflow-x: hidden !important;  // Prevent horizontal scroll
    }

    // Make text wrap if needed
    ::v-deep td, ::v-deep th {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
        max-width: 100%;
    }
    }

    @keyframes flash {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
    }

    .flash-animation {
        animation: flash 1s infinite;
    }

    .big-board-dashboard-table {
        ::v-deep .v-data-table,
        ::v-deep .v-data-table__wrapper {
            background-color: var(--dark-blue-70) !important;
        }
    }

    .dynamic-table-font {
        ::v-deep th,
        ::v-deep td,
        ::v-deep .v-chip,
        ::v-deep span {
            font-size: inherit !important;
        }
        
        ::v-deep table {
            font-size: inherit !important;
        }
    }

    .view-toggle-icon-container {
        ::v-deep .view-toggle-icon {
            color: white !important;
        }
    }

    ::v-deep tbody tr:hover .view-toggle-icon-container .view-toggle-icon {
        color: black !important;
    }

    ::v-deep tbody tr.highlight .view-toggle-icon-container .view-toggle-icon {
        color: black !important;
    }

    /* v-chip hover: match row highlight so chips don't look flat (unscoped so it reaches slot content) */
    .big-board-dashboard-table ::v-deep tbody tr:hover .v-chip,
    .big-board-dashboard-table ::v-deep tbody tr.highlight .v-chip {
        filter: brightness(1.2) !important;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15) !important;
    }

</style>
